import ModelInterface from 'src/models/ModelInterface'
import {RawWikiNode} from '@/types/entity/RawWiki'
import store from '@/store/index'
import Vue from 'vue'

class WikiNode extends ModelInterface<RawWikiNode> {

  constructor (data: RawWikiNode) {
    super(data)
  }

  public getData () {
    return this.data
  }

  public getTitle () {
    return this.data.title;
  }

  public getParentId () {
    return this.data.parent
  }

  public addChildren (child: WikiNode) {
    if (!this.data.children) {
      Vue.set(this.data, 'children', [])
    }
    this.data.children!.push(child)
  }

  public getChildren () {
    return this.data.children || []
  }

  public getNumPages () {
    return this.data.num_pages;
  }

  get children () {
    return this.getChildren()
  }

  get title () {
    return this.getTitle()
  }

  get isNode () {
    return true
  }

  get leaf (): boolean {
    if (!this.getNumPages() && !this.getChildren().length) {
      return true;
    } else {
      return false;
    }
  }
}

export default WikiNode